// Pure logic for GLB previews (shared by the tile and drawer hooks).

// Browsers cap live WebGL contexts (around 16). Each GLB preview owns one,
// so a slot registry bounds live previews per page: later previews wait on
// a fallback icon until a slot is released (tile removed, tab switch,
// drawer closed).
export function createSlots(max) {
  const live = new Set()
  const waiting = []

  return {
    max,
    acquire(id) {
      if (live.size < max) {
        live.add(id)
        return true
      }
      waiting.push(id)
      return false
    },
    release(id) {
      live.delete(id)
      const idx = waiting.indexOf(id)
      if (idx >= 0) waiting.splice(idx, 1)
      // Only a released live slot makes room for the next waiter; dropping a
      // queued id frees nothing.
      if (waiting.length > 0 && live.size < max) {
        const next = waiting.shift()
        live.add(next)
        return next
      }
      return undefined
    },
  }
}

export const slots = createSlots(12)

const FIT_MARGIN = 1.35

// Camera distance that fits an object's bounding size on screen, with a
// margin. `aspect` is width/height of the viewport, `fovDeg` the vertical
// field of view in degrees.
export function fitDistance(size, aspect, fovDeg) {
  const maxDim = Math.max(size.x, size.y, size.z, 1e-6)
  const vFov = (fovDeg * Math.PI) / 180
  const fromHeight = (maxDim / 2 / Math.tan(vFov / 2)) * FIT_MARGIN
  const hFov = 2 * Math.atan(Math.tan(vFov / 2) * Math.max(aspect, 1e-6))
  const fromWidth = (maxDim / 2 / Math.tan(hFov / 2)) * FIT_MARGIN
  return Math.max(fromHeight, fromWidth)
}
